// extracted by mini-css-extract-plugin
export var modal = "_b8-0";